import { render, staticRenderFns } from "./StandupView.vue?vue&type=template&id=d9facf76&scoped=true&"
import script from "./StandupView.vue?vue&type=script&lang=js&"
export * from "./StandupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9facf76",
  null
  
)

export default component.exports